export default __webpack_public_path__ + "static/media/falco_white.2be465a9.png";